<template>
  <div />
</template>
<script>
import { DepositQuery } from '@/api/payment'
import { showNotice } from '@/utils/tool'

export default {
  name: 'DepositReturn',
  data() {
    return {
      ref_id: new URL(window.location.href || document.location.href).searchParams.get('ref_id'),
      message: null
    }
  },
  computed: {
    submitLabel() {
      return this.$te('Bao.submit') ? this.$t('Bao.submit') : 'OK'
    },
    titleLabel() {
      return this.$te('Bao.notice') ? this.$t('Bao.notice') : 'Notice'
    }
  },
  mounted() {
    const self = this

    if (!this.ref_id) {
      showNotice(this.$t('Bao.order_not_found'), function() {
        self.$router.push({ name: 'DepositRecord' }).catch(() => {
        })
      })
    } else {
      DepositQuery({ ref_id: this.ref_id }).then((response) => {
        // 傳給app
        try {
          window.webkit.messageHandlers.depositFinish.postMessage(response.data.msg)
          return
        } catch (e) {
          console.log(e)
        }
        try {
          window.JSInterface.depositFinish(response.data.msg)
          return
        } catch (e) {
          console.log(e)
        }

        showNotice(response.data.msg, function() {
          self.$router.push({ name: 'DepositRecord' }).catch(() => {
          })
        })
      }).catch((error) => {
        // 傳給app
        try {
          window.webkit.messageHandlers.depositFinish.postMessage(error.response.data.msg)
        } catch (e) {
          console.error(e)
        }
        try {
          window.JSInterface.depositFinish(error.response.data.msg)
        } catch (e) {
          console.error(e)
        }

        showNotice(error.response.data.msg, function() {
          self.$router.push({ name: 'DepositRecord' }).catch(() => {
          })
        })
      })
    }
  },
  methods: {
  }
}
</script>
